module.exports = "/static-assets/_next/static/images/shopping-cart-2d823a5f8aa17509ece0b2eb88a9ec33.svg";